<template>
  <footer class="mt-12">
    <div class="bg-neutral-50 mt-5">
      <div class="container 2xl:max-w-(--breakpoint-2xl) mx-auto pb-8 pt-8 px-6">
        <div class="grid lg:grid-cols-2 xl:grid-cols-5 gap-y-12 xl:gap-x-6">
          <div v-for="link in headerFooterLinks?.footer?.link_list" :key="link.title">
            <div v-if="link.title" class="text-xl font-semibold text-left">
              {{ link.title }}
            </div>
            <ul v-if="link.items" class="text-left">
              <li v-for="item in link.items" :key="item" class="mt-4">
                <a
                  v-if="item.masked === false"
                  :href="item.url"
                >
                  {{ item.title }}
                </a>
                <UiMaskedLink
                  v-else
                  :href="item.url"
                >
                  {{ item.title }}
                </UiMaskedLink>
              </li>
            </ul>
          </div>
          <div class="lg:col-span-2 xl:col-span-1">
            <div
              v-if="headerFooterLinks?.footer?.social_networks?.length > 0"
              class="text-xl font-semibold text-left"
            >
              {{ t('follow_us') }}
            </div>
            <div
              v-if="headerFooterLinks?.footer?.social_networks?.length > 0"
              class="text-left"
            >
              <template v-for="social_network in headerFooterLinks?.footer?.social_networks" :key="social_network.app">
                <UiMaskedLink
                  tag="span"
                  :aria-label="t('social_network', { network: social_network.title ?? socialDefault[social_network.app].title } )"
                  :title="social_network.title ?? socialDefault[social_network.app].title"
                  :href="social_network.url ?? socialDefault[social_network.app].url"
                >
                  <UiIcon :src="social_network.logo ?? socialDefault[social_network.app].logo" width="50" height="50" class="fill-neutral-500 inline-block mt-3 mr-2" aria-hidden="true" />
                </UiMaskedLink>
              </template>
            </div>
            <div class="text-xl font-semibold text-left mt-7">
              {{ t('payment') }}
            </div>
            <div class="text-left flex flex-wrap gap-x-2 gap-y-3 mt-3" aria-hidden="true">
              <UiIcon src="/svg/payment-methods/applepay.svg" width="54" height="35" class="border border-neutral-200 fill-neutral-500 bg-white inline-block rounded-sm p-1" />
              <UiIcon src="/svg/payment-methods/gpay.svg" width="54" height="35" class="border border-neutral-200 fill-neutral-500 bg-white inline-block rounded-sm p-1" />
              <UiIcon src="/svg/payment-methods/paypal.svg" width="54" height="35" class="border border-neutral-200 fill-neutral-500 bg-white inline-block rounded-sm p-1" />
              <UiIcon src="/svg/payment-methods/mastercard.svg" width="54" height="35" class="border border-neutral-200 fill-neutral-500 bg-white inline-block rounded-sm p-1" />
              <UiIcon src="/svg/payment-methods/visa.svg" width="54" height="35" class="border border-neutral-200 fill-neutral-500 bg-white inline-block rounded-sm p-1" />
              <UiIcon src="/svg/payment-methods/ueberweisung.svg" width="54" height="35" class="border border-neutral-200 fill-neutral-500 bg-white inline-block rounded-sm p-1" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-neutral-50 border-t-2 border-neutral-200">
      <div class="container lg:max-w-screen-xxl mx-auto py-4 px-5 text-center text-sm">
        <UiLanguagePlaceholder
          domain="LayoutFooter"
          name="use_1"
          :variables="{ portal_site: (headerFooterLinks?.portal_domain_name ?? '') }"
        />&nbsp;
        <UiMaskedLink tag="span" :href="headerFooterLinks?.footer?.agb?.url ?? '/agb'" class="underline">
          <UiLanguagePlaceholder domain="LayoutFooter" name="agb" />
        </UiMaskedLink>&nbsp;
        <UiLanguagePlaceholder domain="LayoutFooter" name="use_2" />&nbsp;
        <UiMaskedLink tag="span" :href="headerFooterLinks?.footer?.datenschutz?.url ?? '/datenschutz'" class="underline">
          <UiLanguagePlaceholder domain="LayoutFooter" name="privacy_policy" />
        </UiMaskedLink>&nbsp;
        <UiLanguagePlaceholder domain="LayoutFooter" name="use_3" />
      </div>
    </div>
  </footer>
</template>

<script setup>
const t = useTranslations('LayoutFooter').translate
const { links: headerFooterLinks } = usePortalData()

const socialDefault = {
  Pinterest: {
    title: 'Pinterest',
    logo: '/svg/icons/social-media/pinterest.svg',
    url: 'https://www.pinterest.de/travanto/'
  },
  Instagram: {
    title: 'Instagram',
    logo: '/svg/icons/social-media/instagram.svg',
    url: 'https://www.instagram.com/travanto.de/'
  },
  Facebook: {
    title: 'Facebook',
    logo: '/svg/icons/social-media/facebook.svg',
    url: 'https://www.facebook.com/Travanto'
  }
}
</script>

